import * as React from 'react';
import './style.scss';
import { AlpacaPosition } from '../../reducers/positionSlice';
import { PortfolioAllocationComponent } from '../../components/portfolio-allocation';

interface PortfolioPageProps {
	positions: Array<AlpacaPosition>;
}

export const PortfolioPage: React.FC<PortfolioPageProps> = ({ positions }) => {
	return (
		<div className='portfolio-page'>
			<div className='portfolio-header'>
				<h1>Portfolio Allocation</h1>
				<p>View your asset allocation across different holdings</p>
			</div>
			<div className='portfolio-content'>
				<PortfolioAllocationComponent positions={positions} />
			</div>
		</div>
	);
};
